import { createSlice } from "@reduxjs/toolkit";

const loginSlice = createSlice({
  name: "login",
  initialState: {
    user: null,
    token: localStorage.getItem("token") || null,
    isAuthenticated: localStorage.getItem("isAuthenticated") || false,
    loading: false,
    error: null,
    authToken: localStorage.getItem("token") || null,
  },

  reducers: {
    loginStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    loginSuccess: (state, action) => {
      console.log("action", action);
      state.authToken = action.payload.user.authToken;
      state.isAuthenticated = true;
      state.loading = false;

      // Save token to localStorage
      localStorage.setItem("token", action.payload.user.authToken);
      localStorage.setItem("isAuthenticated", true);
    },
    loginFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.isAuthenticated = false;
    },
    logout: (state) => {
      state.authToken = null;
      state.isAuthenticated = false;

      // Remove token from localStorage
      localStorage.removeItem("token");
      localStorage.removeItem("isAuthenticated");
      window.location.href = "/";
    },
    AdduserData: (state, action) => {
      state.user = action.payload;
    },
  },
});

export const {
  loginStart,
  loginSuccess,
  loginFailure,
  logout,
  AdduserData,
  addUserKycSteps,
} = loginSlice.actions;

export default loginSlice.reducer;
